import { Suspense, useEffect } from 'react';
import { TrackingEvents, useTrackingDispatch } from 'modules/analytics';
import { Layout } from 'modules/minimal-ui-theme';
import {
  LazyDeleteShiftErrorAlert,
  LazyDeleteShiftModal
} from 'modules/modals';
import { ShiftDetails, ShiftPageHeader } from 'modules/shift';

export const ShiftDetailsPage = () => {
  const dispatch = useTrackingDispatch();

  useEffect(() => {
    dispatch({
      type: TrackingEvents.OVERVIEW_PAGE_VIEWED
    });
  }, [dispatch]);

  return (
    <Layout header={<ShiftPageHeader />} withFooter>
      <ShiftDetails />
      <Suspense>
        <LazyDeleteShiftModal />
        <LazyDeleteShiftErrorAlert />
      </Suspense>
    </Layout>
  );
};
